import { SiteLogos } from '../../../components';
import { CMSTransformerDataType } from '../../types/common';
const transformSiteLogo = (data: CMSTransformerDataType): SiteLogos => {
  const logos = data.default_logo.images.map((logo: CMSTransformerDataType) => ({
    alt_text: logo.alt_text,
    viewport: logo.viewport,
    url: logo.image.url,
  }));
  return {
    logos,
    componentType: 'site_logo',
  };
};

export default transformSiteLogo;
